import { em } from 'polished'
import styled, { css } from 'styled-components'

export const IconBox = styled.div`
  position: absolute;
  width: ${em(100)};
  height: ${em(100)};
  top: 35%;
  left: 60%;
  transform: translate(-50%, -50%) rotate(-90deg);
  opacity: 0;
  transform-origin: 50% 100%;
  transition-property: transform, opacity;
  transition-duration: ${p => p.theme.animation.timeLong};
  transition-timing-function: ease-in;

  ${p => p.theme.mq.upMd} {
    top: 25%;
    left: 40%;
  }

  ${p => p.theme.mq.upLg} {
    top: 35%;
    left: 60%;
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      opacity: 1;
      transform: translate(-50%, -50%) rotate(0deg);
    `}
`
